<template>
  <v-container fluid class="d-flex justify-center background" style="background-color: #EFF6FC;">
    <div class="ma-2 custom-font pt-4">
      <v-form ref="form_register" v-model="valid" lazy-validation>
        <v-row>
          <v-col cols="12" class="pl-2 ml-2" align="center">
            <v-img
              v-if="profile !== null"
              :src="profile.pictureUrl"
              class="mb-1 size-img"
              style="border-radius: 50%"
            />
            <v-img
              v-else
              style="border-radius: 100%"
              :src="require(`@/assets/image/Group 427323441.png`)"
              class="mb-1 size-img"
            />
          </v-col>
          <v-col cols="12" class="pt-2 px-5 d-flex justify-end">
            <div v-if="edit_item == true">
              <v-btn
                color="#00a99d"
                outlined
                dark
                @click="setEdit('false')"
                small
                width="120"
              >
                <v-icon>mdi-file-edit</v-icon> แก้ไขข้อมูล
              </v-btn>
            </div>
            <div v-else>
              <v-btn
                color="#F1C93B"
                outlined
                dark
                @click="setEdit('true')"
                small
                width="150"
              >
                <v-icon>mdi-file-edit</v-icon> ปิดการแก้ไขข้อมูล
              </v-btn>
            </div>
          </v-col>
        </v-row>
        <v-row v-if="edit_item == true" style="margin-bottom: 40px;">
          <v-col cols="12" sm="12" md="12" xl="12" lg="12" class="my-0 pt-0">
            <div class="d-flex flex-column">
              <span> คำนำหน้า </span>
              <v-text-field
                solo
                v-model="items.account_title_th"
                hide-details="auto"
                dense
                :menu-props="{ bottom: true, offsetY: true }"
                color="#00a99d"
                required
                readonly
                item-color="teal darken-2"
              ></v-text-field>
            </div>
          </v-col>
          <v-col cols="12" sm="12" md="12" xl="12" lg="12" class="pt-0">
            <div class="d-flex flex-column">
              <span> ชื่อ (ภาษาไทย) </span>
              <v-text-field
                solo
                hide-details="auto"
                dense
                readonly
                v-model="items.first_name_th"
                required
                class="custom-border"
              ></v-text-field>
            </div>
          </v-col>
          <v-col cols="12" sm="12" md="12" xl="12" lg="12" class="pt-0">
            <div class="d-flex flex-column">
              <span> นามสกุล (ภาษาไทย) </span>
              <v-text-field
                solo
                hide-details="auto"
                dense
                readonly
                v-model="items.last_name_th"
                required
              ></v-text-field>
            </div>
          </v-col>
          <v-col cols="12">
            <v-row>
              <v-col cols="12" sm="12" md="12" xl="12" lg="12" class="py-0">
                <span>
                  {{ displayIdCard(items.id_card_type) }}
                </span>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="12" md="12" xl="12" lg="12" class="pt-0">
                <v-text-field
                  solo
                  hide-details="auto"
                  dense
                  v-model="items.cid"
                  readonly
                  required
                  v-if="items.id_card_type == 'ID_CARD'"
                ></v-text-field>
                <v-text-field
                  solo
                  hide-details="auto"
                  dense
                  v-model="items.id_card_num"
                  readonly
                  required
                  v-else
                ></v-text-field>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" sm="12" md="12" xl="12" lg="12" class="pt-0">
            <div class="d-flex flex-column">
              <span> วัน / เดือน / ปีเกิด </span>
              <v-text-field
                solo
                hide-details="auto"
                dense
                :value="fomatDate(items.birth_date)"
                readonly
                required
              ></v-text-field>
            </div>
          </v-col>
          <v-col cols="12" sm="12" md="12" xl="12" lg="12" class="pt-0">
            <div class="d-flex flex-column">
              <span> อายุ</span>
              <v-text-field
                solo
                hide-details="auto"
                :value="CalculateAge(items.birth_date)"
                dense
                readonly
              ></v-text-field>
            </div>
          </v-col>
          <v-col cols="12" sm="12" md="12" xl="12" lg="12" class="pt-0">
            <div class="d-flex flex-column">
              <span> หมายเลขโทรศัพท์ </span>
              <v-text-field
                solo
                hide-details="auto"
                dense
                v-model="items.mobile"
                readonly
                required
              ></v-text-field>
            </div>
          </v-col>
          <!-- <v-col cols="12" sm="12" md="12" xl="12" lg="12" class="pt-0">
            <div class="d-flex flex-column">
              <span>เลือกสถานพยาบาล </span>
              <v-text-field
                solo
                hide-details="auto"
                dense
                v-model="hospital"
                readonly
                required
              ></v-text-field>
            </div>
          </v-col> -->
        </v-row>

        <v-row style="margin-bottom: 20px;" v-else>
          <v-col cols="12" sm="12" md="12" xl="12" lg="12" class="my-0 pt-0">
            <div class="d-flex flex-column">
              <span>
                คำนำหน้า<span v-if="edit_item == false" class="red--text"
                  >*</span
                >
              </span>
              <v-autocomplete
                solo
                @input="titleChange()"
                v-model="items.account_title_th"
                :items="titleItems"
                hide-details="auto"
                dense
                class="custom-text-field"
                :menu-props="{ bottom: true, offsetY: true }"
                color="#00a99d"
                :rules="rules.rule_account"
                required
                item-color="teal darken-2"
              >
                <template slot="label">
                  <span class="font-14 text-9a9a9a">เลือกคำนำหน้าชื่อ</span>
                </template></v-autocomplete
              >
            </div>
          </v-col>
          <v-col cols="12" sm="12" md="12" xl="12" lg="12" class="pt-0">
            <div class="d-flex flex-column">
              <span>
                ชื่อ (ภาษาไทย)<span v-if="edit_item == false" class="red--text"
                  >*</span
                >
              </span>
              <v-text-field
                solo
                hide-details="auto"
                dense
                :readonly="view"
                v-model="items.first_name_th"
                :rules="rules.rule_name_th"
                required
                class="custom-border custom-text-field"
              >
                <template slot="label">
                  <span class="font-14 text-9a9a9a">ชื่อ (ภาษาไทย)</span>
                </template></v-text-field
              >
            </div>
          </v-col>
          <v-col cols="12" sm="12" md="12" xl="12" lg="12" class="pt-0">
            <div class="d-flex flex-column">
              <span>
                นามสกุล (ภาษาไทย)<span
                  v-if="edit_item == false"
                  class="red--text"
                  >*</span
                >
              </span>
              <v-text-field
                solo
                hide-details="auto"
                dense
                class="custom-text-field"
                :readonly="view"
                v-model="items.last_name_th"
                :rules="rules.rule_lastname_th"
                required
              >
                <template slot="label">
                  <span class="font-14 text-9a9a9a">นามสกุล (ภาษาไทย)</span>
                </template>
              </v-text-field>
            </div>
          </v-col>
          <v-col cols="12">
            <v-row>
              <v-col cols="12" sm="12" md="12" xl="12" lg="12" class="py-0">
                <span>
                  ประเภทบัตร {{ displayIdCard(items.id_card_type) }}
                  <span v-if="edit_item == false" class="red--text"
                    >*</span
                  ></span
                >
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="12" md="12" xl="12" lg="12" class="pt-0">
                <v-select
                  solo
                  hide-details="auto"
                  dense
                  v-model="items.id_card_type"
                  item-text="text"
                  item-value="value"
                  :items="itemType"
                  disabled="true"
                  class="pr-1 custom-text-field"
                  :menu-props="{ bottom: true, offsetY: true }"
                  :rules="rules.rule_card_type"
                  required
                  color="#00a99d"
                  item-color="teal"
                ></v-select>
              </v-col>
              <v-col cols="12" sm="12" md="12" xl="12" lg="12" class="pt-0">
                <v-text-field
                  solo
                  hide-details="auto"
                  dense
                  v-model="items.cid"
                  :readonly="view"
                  disabled="true"
                  class="custom-text-field"
                  :rules="rules.rule_card_num"
                  @keypress="validateNumber"
                  @input="validateThaiIDCard"
                  :error-messages="err_msg"
                  maxlength="13"
                  required
                  v-if="items.id_card_type == 'ID_CARD'"
                >
                  <template slot="label">
                    <span class="font-14 text-9a9a9a">หมายเลขบัตรประชาชน</span>
                  </template>
                </v-text-field>
                <v-text-field
                  solo
                  hide-details="auto"
                  dense
                  class="custom-text-field"
                  v-model="items.cid"
                  :readonly="view"
                  :rules="rules.rule_passports"
                  required
                  v-else
                >
                  <template slot="label">
                    <span class="font-14 text-9a9a9a">หมายเลข PASSPORT</span>
                  </template>
                </v-text-field>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" sm="12" md="12" xl="12" lg="12" class="pt-0">
            <div class="d-flex flex-column">
              <span> วัน / เดือน / ปีเกิด </span>
              <v-menu
                :readonly="view"
                ref="birth_date"
                v-model="menubirth_date"
                :close-on-content-click="false"
                :return-value.sync="items.birth_date"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    solo
                    dense
                    :value="formatBirthDate"
                    append-icon="mdi-calendar"
                    readonly
                    class="custom-text-field"
                    v-bind="attrs"
                    v-on="on"
                    hide-details="auto"
                    required
                    color="#00a99d"
                  >
                    <template slot="label">
                      <span class="font-14 text-9a9a9a"
                        >วัน / เดือน / ปีเกิด</span
                      >
                    </template>
                  </v-text-field>
                </template>
                <!-- :rules="rules.rule_birth_date"
                            <span class="red--text">*</span> -->
                <v-date-picker
                  ref="picker"
                  v-model="items.birth_date"
                  no-title
                  scrollable
                  :readonly="view"
                  :max="yearmax"
                  locale="th"
                  @input="calculateAge(items.birth_date)"
                  color="#00a99d"
                >
                  <v-spacer></v-spacer>
                  <v-btn text color="#00a99d" @click="cancel_birth()">
                    Cancel
                  </v-btn>
                  <v-btn
                    text
                    color="#00a99d"
                    @click="calculateAge(items.birth_date)"
                  >
                    OK
                  </v-btn>
                </v-date-picker>
              </v-menu>
            </div>
          </v-col>
          <v-col cols="12" sm="12" md="12" xl="12" lg="12" class="pt-0">
            <div class="d-flex flex-column">
              <span> อายุ</span>
              <v-text-field
                solo
                class="custom-text-field"
                hide-details="auto"
                :value="CalculateAge(items.birth_date)"
                dense
                ><template slot="label">
                  <span class="font-14 text-9a9a9a">อายุ</span>
                </template>
              </v-text-field>
            </div>
          </v-col>
          <v-col cols="12" sm="12" md="12" xl="12" lg="12" class="pt-0">
            <div class="d-flex flex-column">
              <span>
                หมายเลขโทรศัพท์<span v-if="edit_item == false" class="red--text"
                  >*</span
                >
              </span>
              <v-text-field
                solo
                class="custom-text-field"
                hide-details="auto"
                dense
                v-model="items.mobile"
                disabled="true"
                :rules="rules.rule_tel"
                required
                @keypress="validateNumber"
                maxLength="10"
              >
                <template slot="label">
                  <span class="font-14 text-9a9a9a">หมายเลขโทรศัพท์</span>
                </template>
              </v-text-field>
            </div>
          </v-col>
          <!-- <v-col cols="12" sm="12" md="12" xl="12" lg="12" class="pt-0">
            <div class="d-flex flex-column">
              <span
                >เลือกสถานพยาบาล<span
                  v-if="edit_item == false"
                  class="red--text"
                  >*</span
                >
              </span>
              <v-autocomplete
                placeholder="เลือกสถานพยาบาล"
                v-model="hospital"
                solo
                :items="item_hospital"
                hide-details="auto"
                item-text="first_name_th"
                item-value="biz_id"
                item-color="teal"
                :rules="rules.rule_hospital"
                dense
              >
                <template v-slot:no-data>
                  <v-list-item>
                    <v-list-item-title> ไม่พบข้อมูล </v-list-item-title>
                  </v-list-item>
                </template></v-autocomplete
              >
            </div>
          </v-col> -->
          <v-col cols="12" sm="12" md="12" xl="12" lg="12" class="pt-5 pb-8">
            <div class="d-flex flex-column">
              <v-btn
                block
                dark
                depressed
                color="#32B1EE"
                :loading="btn_loading"
                type="submit"
                style="border-radius: 8px"
                @click.prevent="clickConfirmed()"
                >ยืนยัน</v-btn
              >
            </div>
          </v-col>
        </v-row>

        <!-- <v-card-actions class="justify-center pt-4 my-4">
          <v-col cols="6" class="pr-2 pl-0"
            ><v-btn block outlined rounded color="#32B1EE">ยกเลิก</v-btn></v-col
          >
          <v-col cols="6" class="pl-2 pr-0"
            ><v-btn
              rounded
              block
              dark
              depressed
              color="#32B1EE"
              :loading="btn_loading"
              type="submit"
              @click.prevent="clickConfirmed()"
              >ยืนยัน</v-btn
            ></v-col
          >
        </v-card-actions> -->
      </v-form>
    </div>
    <v-overlay v-if="dialog_loading" persistent width="300">
      <v-progress-circular
        :size="70"
        :width="7"
        color="#2EA3DB"
        indeterminate
      ></v-progress-circular>
    </v-overlay>
    <ConsentBot ref="dialogConsent" :item="itemConsent" />
  </v-container>
</template>

<script>
import moment from "moment";
import liff from "@line/liff";
import Swal from "sweetalert2";
import get_access_token from "@/services/get_access_token";
// import functioncryto from "@/services/encrypt.js";
import ConsentBot from "@/components/ConsentBot.vue";
export default {
  components: {
    ConsentBot,
  },
  data() {
    return {
      dialog_loading: true,
      edit_item: true,
      dialog: false,
      btn_loading: false,
      panel: [0, 1, 2],
      set_province: [],
      set_amphoe: [],
      set_tambon: [],
      edit: false,
      valid: false,
      view: false,
      menubirth_date: false,
      yearmax: "",
      findHis: "",

      items: {
        age: "",
        mobile: "",
        id_card_type: "ID_CARD",
        id_card_num: "",
        address: {
          house_no: "",
          moo_no: "",
          soi: "",
          province: "",
          amphur: "",
          tambon: "",
          zipcode: "",
        },
        email: "",
        account_title_th: "",
        account_title_eng: "",
        first_name_eng: "",
        first_name_th: "",
        last_name_eng: "",
        last_name_th: "",
        birth_date: "",
        gender: "",
        blood: "",
        HN: "",
        hos_code: "",
        _id: "",
      },
      item_hospital: [],
      hospital: "",
      titleItems: ["เด็กหญิง", "เด็กชาย", "นางสาว", "นาย", "นาง"],
      blood_list: ["A", "B", "O", "AB"],
      itemType: [
        { value: "ID_CARD", text: "บัตรประชาชน" },
        { value: "PASSPORT", text: "PASSPORT" },
      ],
      rules: {
        rule_gender: [(v) => !!v || "กรุณาเลือกเพศ"],
        rule_account: [(v) => !!v || "กรุณาเลือกคำนำหน้าชื่อ"],
        rule_name_th: [(v) => !!v || "กรุณากรอกชื่อ (ภาษาไทย)"],
        rule_lastname_th: [(v) => !!v || "กรุณากรอกนามสกุล (ภาษาไทย)"],
        rule_name_eng: [(v) => !!v || "กรุณากรอกชื่อ (ภาษาอังกฤษ)"],
        rule_lastname_eng: [(v) => !!v || "กรุณากรอกนามสกุล (ภาษาอังกฤษ)"],
        rule_card_type: [(v) => !!v || "กรุณาเลือกประเภทบัตร"],
        rule_card_num: [
          (v) => !!v || "กรุณากรอกหมายเลขบัตร",
          (v) => /^([0-9])+$/.test(v) || "กรอกได้เฉพาะตัวเลข",
          (v) => v.length === 13 || "กรอก 13 หลัก",
        ],
        rule_passports: [(v) => !!v || "กรุณากรอกหมายเลข Passport"],
        rule_birth_date: [(v) => !!v || "กรุณาเลือกวันเกิด"],
        rule_tel: [
          (v) => !!v || "กรุณากรอกหมายเลขโทรศัพท์",
          (v) => /^([0-9])+$/.test(v) || "กรอกได้เฉพาะตัวเลข",
          (v) => v.length === 9 || v.length === 10 || "กรอก 9-10 หลัก",
        ],
        rule_hospital: [(v) => !!v || "กรุณาเลือกสถานพยาบาล"],
        rule_house_no: [(v) => !!v || "กรุณากรอกบ้านเลขที่"],
        rule_province: [(v) => !!v || "กรุณาเลือกจังหวัด"],
        rule_amphur: [(v) => !!v || "กรุณาเลือกอำเภอ"],
        rule_tambon: [(v) => !!v || "กรุณาเลือกตำบล"],
        rule_zipcode: [(v) => !!v || "กรุณากรอกรหัสไปรษณีย์"],
        rule_employee_id: [(v) => !!v || "กรุณากรอกรหัสพนักงาน"],
      },
      err_msg: "",
      profile: null,
      itemConsent: {
        business_id:
          this.$route.query["biz_id"] || this.$route.query["business_id"],
        share_token: this.$route.query.share_token || "",
      },
    };
  },
  computed: {
    formatBirthDate() {
      var year1 = "";
      var year2 = "";
      if (this.items.birth_date === undefined || this.items.birth_date === "")
        return "";
      year1 = moment(this.items.birth_date).locale("th").format("YYYY");
      year2 = (parseInt(year1) + 543).toString();
      return moment(this.items.birth_date)
        .locale("th")
        .format("DD/MM/" + year2);
    },
  },
  watch: {
    menubirth_date(val) {
      val &&
        this.$nextTick(() => (this.$refs.picker.internalActivePicker = "YEAR"));
    },
  },
  async created() {
    this.dialog = true;
    this.initLIFF();
    this.getHospital();
    var now_date = new Date();
    this.yearmax = now_date.getFullYear() - 7 + "-" + 12 + "-" + 31;
  },
  methods: {
    async initLIFF() {
      try {
        await liff.init({ liffId: process.env.VUE_APP_LIFF_ID_PROFILE });
        if (!liff.isLoggedIn()) {
          liff.login();
        } else {
          const profile = await liff.getProfile();
          this.profile = profile;
          console.log("profile", this.profile);
          await this.checkPatient(this.profile.userId);
        }
      } catch (error) {
        console.error("LIFF initialization failed", error);
      }
    },
    checkPatient(item) {
      try {
        const params = new URLSearchParams();
        params.append("line_user_id", item);
        this.axios
          .get(
            `${process.env.VUE_APP_BACKEND_URL}/v1/lineoa/check-patient?${params}`
          )
          .then(async (res) => {
            // console.log("🚀 ~ .then ~ res:sssssssssssssssssssssssssss", res);
            if (
              res.data.result == "success" &&
              res.data.message == "This user exist."
            ) {
              await this.getPatient(item);
              this.check_patient = true;
              this.share_token = res.data.data.shared_token;
              sessionStorage.access_token = await get_access_token(
                res.data.data.shared_token
              );
              await this.checkConsent();
            } else {
              Swal.fire({
                html: `
              <span style="color: black; font-size: 24px; font-family: Sarabun, sans-serif;">
                <strong>ไม่สามารถเข้าใช้งานระบบได้</strong>
              </span><br>
              <span style="color: black; font-size: 20px; font-family: Sarabun, sans-serif;">
                เนื่องจากท่านยังไม่ได้ลงทะเบียนเข้าใช้งานระบบ
              </span>
              `,
                icon: "warning",
                showCancelButton: false,
                confirmButtonColor: "#3085d6",
                allowOutsideClick: false,
                // cancelButtonColor: "#d33",
                confirmButtonText: "ลงทะเบียน",
                // cancelButtonText: "ยกเลิก",
              }).then((result) => {
                if (result.isConfirmed) {
                  this.$router.push(
                    `/management/register-line?user_id=${this.profile.userId}&username=${this.profile.displayName}&from=profile`
                  );
                }
              });
            }
          });
      } catch (err) {
        console.error();
      }
    },
    async checkConsent() {
      try {
        const params = new URLSearchParams();
        params.append("share_token", this.share_token);
        await this.axios
          .get(process.env.VUE_APP_BACKEND_URL + `/consent/v1/check?${params}`)
          .then(async (res) => {
            // console.log("res", res);
            if (res.data.result == "success" && res.data.data === true) {
              this.consent = true;
            } else if (
              res.data.result == "success" &&
              res.data.data === false
            ) {
              Swal.fire({
                html: `
              <span style="color: black; font-size: 24px; font-family: Sarabun, sans-serif;padding-bottom: 10px; display: inline-block;">
                <strong>ความยินยอม</strong>
              </span><br>
              <span style="color: black; font-size: 20px; font-family: Sarabun, sans-serif;">
                แบบฟอร์มบันทึกความยินยอม
              </span>
              `,
                imageUrl: `${require("@/assets/OnePlatform/Group 11.svg")}`,
                imageWidth: 150,
                imageHeight: 150,
                showCancelButton: false,
                confirmButtonColor: "#3085d6",
                allowOutsideClick: false,
                // cancelButtonColor: "#d33",
                confirmButtonText: "แบบฟอร์มบันทึกความยินยอม",
                // cancelButtonText: "ยกเลิก",
              }).then((result) => {
                if (result.isConfirmed) {
                  this.itemConsent.share_token = this.share_token;
                  this.$refs.dialogConsent.openDialog(this.share_token);
                }
              });
            } else {
              this.$swal({
                type: "error",
                width: "auto",
                icon: "error",
                backdrop: false,
                showConfirmButton: false,
                timer: 1000,
              });
            }
          });
      } catch (error) {
        console.log("🚀 ~ error:", error);
        this.$swal({
          type: "error",
          title: "ระบบมีปัญหา",
          text: "กรุณาลองใหม่อีกครั้งค่ะ",
          width: "auto",
          icon: "error",
          allowOutsideClick: () => {
            const popup = this.$swal.getPopup();
            popup.classList.remove("swal2-show");
            setTimeout(() => {
              popup.classList.add("shake-sweetalert");
            });
            setTimeout(() => {
              popup.classList.remove("shake-sweetalert");
            }, 500);
            return false;
          },
          confirmButtonText: "OK",
          confirmButtonColor: "#00A99D",
        }).then((result) => {
          if (result.isConfirmed) {
            window.location.reload();
          }
        });
      }
    },
    getPatient(item) {
      try {
        this.dialog_loading = true;
        const params = new URLSearchParams();
        params.append("line_user_id", item);
        this.axios
          .get(`${process.env.VUE_APP_BACKEND_URL}/v1/lineoa/patient?${params}`)
          .then((res) => {
            console.log("🚀 ~ .then ~ res:", res);
            if (res.data.result == "success") {
              this.items = res.data.data;
              // this.items.cid = functioncryto.decrypt(this.items.cid);
              this.dialog_loading = false;
              console.log("🚀 ~ .then ~ this.items:", this.items);
            }
          });
      } catch (err) {
        console.error();
      }
    },
    confirmHospital() {
      this.dialog = false;
      this.$router.push({
        path: "/management/profile",
        query: {
          share_token: "324265892276395",
        },
      });
    },
    genderChange() {
      if (this.items.age) {
        switch (this.items.gender) {
          case "ชาย":
            if (this.items.age <= 14) {
              this.items.account_title_th = "เด็กชาย";
              this.items.account_title_eng = "Mr";
              this.titleItems = ["เด็กชาย"];
            } else if (this.items.age > 14) {
              this.items.account_title_th = "นาย";
              this.items.account_title_eng = "Mr";
              this.titleItems = ["นาย"];
            } else {
              this.items.account_title_eng = "Mr";
              this.titleItems = ["เด็กชาย", "นาย"];
            }
            break;
          case "หญิง":
            if (this.items.age <= 14) {
              this.items.account_title_th = "เด็กหญิง";
              this.items.account_title_eng = "Miss";
              this.titleItems = ["เด็กหญิง"];
            } else if (this.items.age > 14) {
              this.items.account_title_th = "นางสาว";
              this.items.account_title_eng = "Miss";
              this.titleItems = ["นางสาว", "นาง"];
            } else {
              this.items.account_title_eng = "Miss";
              this.titleItems = ["เด็กหญิง", "นางสาว", "นาง"];
            }
            break;
          default:
            break;
        }
      } else {
        if (this.items.gender === "ชาย") {
          this.items.account_title_th = "เด็กชาย";
          this.items.account_title_eng = "Mr";
          this.titleItems = ["เด็กชาย", "นาย"];
        }
        if (this.items.gender === "หญิง") {
          this.items.account_title_th = "เด็กหญิง";
          this.items.account_title_eng = "Miss";
          this.titleItems = ["เด็กหญิง", "นางสาว", "นาง"];
        }
      }
    },

    titleChange(age) {
      const hasAge = age || this.items.age;

      if (hasAge) {
        switch (true) {
          case (this.items.account_title_th === "นาย" ||
            this.items.account_title_th === "เด็กชาย") &&
            age <= 14:
            this.items.gender = "ชาย";
            this.items.account_title_th = "เด็กชาย";
            this.titleItems = ["เด็กชาย"];
            break;
          case (this.items.account_title_th === "นาย" ||
            this.items.account_title_th === "เด็กชาย") &&
            age > 14:
            this.items.gender = "ชาย";
            this.items.account_title_th = "นาย";
            this.titleItems = ["นาย"];
            break;
          case (this.items.account_title_th === "นาง" ||
            this.items.account_title_th === "นางสาว" ||
            this.items.account_title_th === "เด็กหญิง") &&
            age <= 14:
            this.items.gender = "หญิง";
            this.items.account_title_th = "เด็กหญิง";
            this.titleItems = ["เด็กหญิง"];
            break;
          case (this.items.account_title_th === "นาง" ||
            this.items.account_title_th === "นางสาว" ||
            this.items.account_title_th === "เด็กหญิง") &&
            age > 14:
            this.items.gender = "หญิง";
            if (this.items.account_title_th === "นาง") {
              this.items.account_title_th = "นาง";
            } else {
              this.items.account_title_th = "นางสาว";
            }
            this.titleItems = ["นางสาว", "นาง"];
            break;
          default:
            break;
        }
      } else {
        if (
          this.items.account_title_th === "นาย" ||
          this.items.account_title_th === "เด็กชาย" ||
          this.items.gender === "ชาย"
        ) {
          this.items.gender = "ชาย";
          this.titleItems = ["เด็กชาย", "นาย"];
        }
        if (
          this.items.account_title_th === "นาง" ||
          this.items.account_title_th === "นางสาว" ||
          this.items.account_title_th === "เด็กหญิง" ||
          this.items.gender === "หญิง"
        ) {
          this.items.gender = "หญิง";
          this.titleItems = ["เด็กหญิง", "นางสาว", "นาง"];
        }
      }
    },
    displayIdCard(idcard) {
      if (idcard === "" || idcard === undefined) {
        this.items.id_card_type = "ID_CARD";
        return "หมายเลขบัตรประชาชน";
      }
      if (idcard === "PASSPORT") {
        this.items.id_card_type = "PASSPORT";
        return "PASSPORT";
      }
      return "หมายเลขบัตรประชาชน";
    },
    calculateAge(date) {
      if (date) {
        this.menubirth_date = false;
        this.$refs.birth_date.save(date);
        const y = Math.floor(moment.duration(moment().diff(date)).asYears());
        this.items.age = y.toString();
        this.titleChange(this.items.age);
      }
    },
    cancel_birth() {
      this.menubirth_date = false;
      this.$refs.birth_date.save("");
      this.items.age = "";
    },
    clickConfirmed() {
      if (!this.$refs.form_register.validate()) {
        this.$swal.fire({
          icon: "error",
          html: `
              <span style="color: black; font-size: 24px; font-family: Sarabun, sans-serif;padding-bottom: 20px; display: inline-block">
                <strong>กรุณากรอกข้อมูลให้ถูกต้อง</strong>
              </span>
              `,
          timer: 3000,
          showConfirmButton: false,
          showCloseButton: false,
        });
        return;
      }
      this.btn_loading = true;
      // let cid_value = functioncryto.encrypt(this.items.id_card_num);
      const params = new URLSearchParams();
      params.append("line_user_id", this.profile.userId);
      let data = {
        gender: this.items.gender,
        account_title_th: this.items.account_title_th,
        first_name_th: this.items.first_name_th,
        last_name_th: this.items.last_name_th,
        mobile: this.items.mobile,
        birth_date: this.items.birth_date,
        biz_id: this.items.biz_id,
        cid: this.items.cid,
        age: this.items.age,
        line_user_id: this.profile.userId,
        line_user_name: this.profile.displayName,
      };
      console.log("🚀 ~ clickConfirmed ~ data:ddddddddddddddddddddddddd", data);
      this.axios
        .put(
          `${process.env.VUE_APP_BACKEND_URL}/v1/lineoa/update-patient?${params}`,
          data
        )
        .then((res) => {
          if (res.status == 200 && res.data) {
            this.$swal.fire({
              icon: "success",
              html: `
              <span style="color: black; font-size: 24px; font-family: Sarabun, sans-serif;padding-bottom: 20px; display: inline-block">
                <strong>บันทึกข้อมูลสำเร็จ</strong>
              </span>
              `,
              timer: 3000,
              showConfirmButton: false,
              showCloseButton: false,
            });
            this.edit_item = true;
            this.btn_loading = false;
            this.getPatient(this.profile.userId);
          }
        });
    },
    validateNumber: (event) => {
      const keyCode = event.keyCode;
      if (keyCode < 48 || keyCode > 57) {
        event.preventDefault();
      }
    },
    validateThaiIDCard() {
      // ตรวจสอบเลขประจำตัวประชาชน
      var sum = 0;
      for (var i = 0; i < 12; i++) {
        sum += parseInt(this.items.id_card_num.charAt(i)) * (13 - i);
      }

      // ตรวจสอบเลขความถูกต้อง (Check Digit)
      if (
        (11 - (sum % 11)) % 10 !==
        parseInt(this.items.id_card_num.charAt(12))
      ) {
        this.err_msg = "รูปแบบเลขประจำตัวประชาชนไม่ถูกต้อง";
      } else {
        this.err_msg = "";
      }
    },
    getHospital() {
      try {
        this.axios
          .get(`${process.env.VUE_APP_BACKEND_URL}/v1/lineoa/organization`)
          .then((res) => {
            // console.log("🚀 ~ .then ~ res:", res);
            if (res.status == 200 && res.data) {
              this.item_hospital = res.data.data;
            }
          });
      } catch (err) {
        console.error();
      }
    },
    setEdit(item) {
      if (item == "false") {
        this.edit_item = false;
      } else {
        this.edit_item = true;
        this.getPatient(this.profile.userId);
      }
    },
    fomatDate(date) {
      var year1 = moment(date).locale("th").format("YYYY");
      var year2 = (parseInt(year1) + 543).toString();
      return moment(date)
        .locale("th")
        .format("D MMMM " + year2);
    },
    CalculateAge(birthDate) {
      const birth = new Date(birthDate);
      const today = new Date();
      let age = today.getFullYear() - birth.getFullYear();
      const monthDiff = today.getMonth() - birth.getMonth();

      // ตรวจสอบว่าเดือนเกิดยังมาไม่ถึง หรือวันที่ยังมาไม่ถึงในปีนี้
      if (
        monthDiff < 0 ||
        (monthDiff === 0 && today.getDate() < birth.getDate())
      ) {
        age--;
      }

      return age;
    },
  },
};
</script>

<style scoped>
::v-deep
  .v-text-field.v-text-field--solo:not(.v-text-field--solo-flat)
  > .v-input__control
  > .v-input__slot {
  border: 1px solid #e8e9e9;
  box-sizing: border-box;
  border-radius: 6px;
  box-shadow: none;
}

::v-deep .disable-textfield > .v-input__control > .v-input__slot {
  background: #e8e9e9 !important;
}
/* .background {
  background-image: url("../../assets/img/bg2.png");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: bottom;
  width: 100%;
  height: 100%;
} */

.size-img {
  width: 200px;
  height: 200px;
}
.custom-border
  .v-input__control
  .v-field--solo:not(.v-field--disabled)
  .v-field__outline {
  border-color: #00a99d !important;
}
::v-deep .v-list-item--link:before {
  /* border-radius: 5px; */
  background-color: #32b1ee;
}
.v-list-item-group .v-list-item--active {
  color: #061b2e;
  background: #000000;
}

.bottoMrght {
  display: flex !important;
  justify-content: end !important;
  align-items: end !important;
}
::v-deep .v-messages__message {
  line-height: 18px !important;
}

::v-deep .v-input input {
  line-height: 1.8rem !important;
  text-indent: 4px !important;
}

/* .custom-text-field >>> input::placeholder {
  font-family: "Angsana New", sans-serif;
  font-size: 22px;
  font-weight: 400;
  color: #acadad !important;
} */

::v-deep .v-list-item .v-list-item__title,
.v-list-item .v-list-item__subtitle {
  line-height: 1.8rem !important;
}
</style>
